module.exports = __webpack_public_path__ + "static/media/everyday_digital_and_weekend_papers.0da0ab01.webp";